import swapVideoSource from "./swap-video-source";
import { debounce } from '../../utils/utils'

export async function loadVideo() {
    const videos = document.querySelectorAll(".landing-page-hero:not(.autoplay-video) video");
    if (videos.length === 0) return;

    const origSrcMap = new Map();

    for (const video of videos) {
        const origSrc = await swapVideoSource(video, window.innerWidth < 768);
        origSrcMap.set(video, origSrc);
        try {
            await video.play();
        } catch (err) {
            console.warn("Video playback failed:", err);
        }
    }

    const handleOrientationChange = async () => {
        for (const video of videos) {
            const origSrc = origSrcMap.get(video);
            if (origSrc) {
                video.setAttribute("src", origSrc);
            }
            await swapVideoSource(video, window.innerWidth < 768);
            try {
                await video.play();
            } catch (err) {
                console.warn("Video playback failed after orientation change:", err);
            }
        }
    };

    window.addEventListener("orientationchange", debounce(handleOrientationChange, 300));
}

document.addEventListener("DOMContentLoaded", async () => await loadVideo());

const isCorrectSource = (sourceUrl, mobileUrlCheck, mobileBreakPoint) => {
    if (!sourceUrl) return false;
    const isMobile = window.innerWidth < mobileBreakPoint;
    const isMobileSource = sourceUrl.endsWith(mobileUrlCheck);
    return (isMobile && isMobileSource) || (!isMobile && !isMobileSource);
};

const checkHeroVideo = async () => {
    const video = document.querySelector(".landing-page-hero.autoplay-video video");
    if (!video) return;
    
    const firstSource = video.querySelector('source:first-child');
    const videoSrc = firstSource ? firstSource.getAttribute("src") : video.getAttribute("src");
    if (!videoSrc) return;
    
    const mobileSuffix = "-mobile.mp4";
    const desktopSuffix = ".mp4";
    const isMobileSrc = videoSrc.endsWith(mobileSuffix);
    const desktopSrc = isMobileSrc ? videoSrc.replace(mobileSuffix, desktopSuffix) : videoSrc;
    const mobileSrc = isMobileSrc ? videoSrc : videoSrc.replace(desktopSuffix, mobileSuffix);
    
    const updateVideoSource = () => {
        const firstSource = video.querySelector('source:first-child');
        const videoSourceUrl = video.getAttribute("src") || (firstSource ? firstSource.getAttribute("src") : null);
        const mobileBreakpoint = 768;
        
        if (!isCorrectSource(videoSourceUrl, mobileSuffix, mobileBreakpoint)) {
            video.setAttribute("src", window.innerWidth < mobileBreakpoint ? mobileSrc : desktopSrc);
        }
    };
    
    window.addEventListener("resize", debounce(updateVideoSource, 300));
    updateVideoSource();
};

const initiateModalIFrame = () => {
    document.querySelectorAll(".youtube-modal-wrapper").forEach((modalWrapper) => {
        const videoWrapper = modalWrapper.querySelector(".video-wrap");
        const playButton = modalWrapper.querySelector(".play-button");
        const videoLink = modalWrapper.dataset.src;
        const iFrameTag = `<iframe class="embed-responsive-item" id="frmYoutube" src="${videoLink}?enablejsapi=1" allowFullScreen="allowfullscreen" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" width="850" height="480"></iframe>`;
        
        playButton.addEventListener("click", () => {
            videoWrapper.querySelector('.embed-responsive').innerHTML = iFrameTag;
            videoWrapper.classList.add("playing");
        });
    });
};

window.addEventListener("DOMContentLoaded", () => {
    checkHeroVideo();
    initiateModalIFrame();
});